
define('modules/application/wizard/classes/apartmentInterface',[
  "app",

  // Libs
  "backbone",

  //Classes
  "./genericEnabler"

],

function(app, Backbone, genericEnabler) {

  var apartmentInterface   = _.extend({}, genericEnabler, {

    Views : {
      titleBar  : genericEnabler.Views.titleBar.extend(),
      content   : genericEnabler.Views.content.extend({

        events   : _.extend(_.extend({}, genericEnabler.Views.content.prototype.events), {
          "click .toggleInfoButton" : "toggleInfos"
        }),

        toggleInfos : function(e) {
          return genericEnabler.Views.content.prototype.toggleInfos(e, this);
        },

        afterRender                            : function() {
          if (!this.model.get("enabled")) {
            this.$el.html("<h4 class='alert'>"+$.i18n._("IDS_W1_9102")+"</h4>");
          }
          window.customizeFormElements.call();
        }
      })
    },

    Model       : genericEnabler.Model.extend({
      defaults  : _.extend({
        name : "IDS_WAV8_5",
        quote : "IDS_WAV1_604",
        value : false,
        infoQuote : "IDS_WGENTT_000027"}, genericEnabler.Model.prototype.defaults),

      initialize                : function() {
        genericEnabler.Model.prototype.initialize.apply(this);

        this.bind("change:value",                               this.valueChangedEventHandler,        this);

        window.BticinoS4B.eventAggregator.unbind("currentDeliver:requested",  this.deliverCurrent);
        window.BticinoS4B.eventAggregator.bind("currentDeliver:requested",    this.deliverCurrent,                  this);

        BticinoS4B.Instances.Models.ApplicationModel.bind("change:filterId",                       this.systemFilterUpdatedEventHandler, this);

        window.BticinoS4B.eventAggregator.unbind("modelDeliver:request",      this.deliverModel);
        window.BticinoS4B.eventAggregator.bind("modelDeliver:request",        this.deliverModel,                    this);

        this.systemFilterUpdatedEventHandler();
      },

      enable                    : function() {
        var vdeExpansionLength  = BticinoS4B.Instances.Models.ApplicationModel.get("vdeExpansionLength")      ? BticinoS4B.Instances.Models.ApplicationModel.get("vdeExpansionLength")      : 0,
            maxVdeExpansion     = BticinoS4B.Instances.Models.ApplicationModel.get("maxVdeExpansion")         ? BticinoS4B.Instances.Models.ApplicationModel.get("maxVdeExpansion")         : 0,
            maxVde              = BticinoS4B.Instances.Models.ApplicationModel.get("maxVde")                  ? BticinoS4B.Instances.Models.ApplicationModel.get("maxVde")(true)                : 0,
            bonusVdes           = BticinoS4B.Instances.Models.ApplicationModel.get("bonusVde")                ? BticinoS4B.Instances.Models.ApplicationModel.get("bonusVde")                : 0,
            vdesLength          = BticinoS4B.Instances.Models.ApplicationModel.get("vdesCollectionLength")     ? BticinoS4B.Instances.Models.ApplicationModel.get("vdesCollectionLength")     : 0,
            sourcesLength       = BticinoS4B.Instances.Models.ApplicationModel.get("sourcesCollectionLength") ? BticinoS4B.Instances.Models.ApplicationModel.get("sourcesCollectionLength") : 0,
            canProceed          = true;

        //Calculating conditions
        canProceed = ( vdesLength + 1 - bonusVdes ) <= maxVde;


        if (canProceed)
          genericEnabler.Model.prototype.enable.apply(this);
        else
        {
          genericEnabler.Model.prototype.disable.apply(this);
          this.trigger("render:requested");
          alert($.i18n._('IDS_W1_9128'));
        }
      },

      valueChangedEventHandler  : function() {
        BticinoS4B.Instances.Models.ApplicationModel.set("numberOfApartmentInterface", (this.get("value") ? 1 : 0) );
        window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
        this.trigger("render:requested");
      },

      retrieveProducts                : function() {
       if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId")) {
          var that = this;
          BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(604, function(data) {
            var packages = data.packages;
            if (packages.length>0)
            {
              _.extend(that.attributes, packages[0]);
              BticinoS4B.Instances.Models.ApplicationModel.getProducts(packages[0].packageClassId, function(data) {
                data.products         = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
                var products          = _.filter(data.products, function(product){return (product.mnemonic===1);});
                var secondaryProducts = _.filter(data.products, function(product){return (product.mnemonic!==1);});

                if (products.length>0)
                {
                  _.extend(that.attributes, products[0]);
                }

                that.set("secondaryProducts", secondaryProducts);
                window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
              });
            }
          });
        }
      },

      deliverCurrent                  : function() {
        //Helper method for consumption send
        var sendConsumption        = function(consumption) {
          if (consumption)
          {
            var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");

            if (consumption<0)
            {
              consumptionIndicatorModel.addConversationSupplyCurrent(consumption);
              consumptionIndicatorModel.addSoundDiffusionSupplyCurrent(consumption);
            }
            else
            {
              consumptionIndicatorModel.addConversationCurrentConsumption(consumption);
              consumptionIndicatorModel.addSoundDiffusionCurrentConsumption(consumption);
            }
          }
        };

        if (this.get("specialVars")) {
          var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");

          if (!(this.get("specialVars") instanceof Object))
            this.attributes.specialVars = JSON.parse(this.attributes.specialVars);

          var currentConsumption        = this.get("specialVars").currentConsumption;

          if (this.get("value"))
          {

            if (this.get("specialVars"))
            {
              if ( (this.get("specialVars").consumptionGroupId) && (this.get("specialVars").groupExtraConsumption) )
              {
                var consumptionGroupId                = this.get("specialVars").consumptionGroupId.toString();
                var groupExtraConsumption             = this.get("specialVars").groupExtraConsumption;
                var conversationMaxExtraConsumptions  = BticinoS4B.Instances.Models.ApplicationModel.get("conversationMaxExtraConsumption");
                var soundDiffusionMaxExtraConsumptions= BticinoS4B.Instances.Models.ApplicationModel.get("soundDiffusionMaxExtraConsumption");

                if ( (!conversationMaxExtraConsumptions[consumptionGroupId]) || (conversationMaxExtraConsumptions[consumptionGroupId]<groupExtraConsumption) )
                  conversationMaxExtraConsumptions[consumptionGroupId] = groupExtraConsumption;

                if ( (!soundDiffusionMaxExtraConsumptions[consumptionGroupId]) || (soundDiffusionMaxExtraConsumptions[consumptionGroupId]<groupExtraConsumption) )
                  soundDiffusionMaxExtraConsumptions[consumptionGroupId] = groupExtraConsumption;

                BticinoS4B.Instances.Models.ApplicationModel.set("conversationMaxExtraConsumption",   conversationMaxExtraConsumptions);
                BticinoS4B.Instances.Models.ApplicationModel.set("soundDiffusionMaxExtraConsumption", soundDiffusionMaxExtraConsumptions);
              }
            }

            sendConsumption(currentConsumption);
          }
        }
      },

      deliverModel                    : function() {
        var apartmentInterfaceItems = [];
          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.apartmentInterface = this;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.apartmentInterface = this;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.apartmentInterface = this;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.apartmentInterface = this;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.apartmentInterface = this;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.apartmentInterface = this;
              break;
          }
        
        BticinoS4B.Instances.Models.ApplicationModel.set("apartmentInterface", this);

        if (this.get("value"))
        {
          apartmentInterfaceItems.push({
            packageClassDescription : this.get("packageClassDescription"),
            packageClassId          : this.get("packageClassId"),
            packageClassLabel       : this.get("packageClassLabel"),
            price                   : this.get("price"),
            productCode             : this.get("productCode"),
            productDescription      : this.get("productDescription"),
            productInDepth          : this.get("productInDepth"),
            productLabel            : this.get("productLabel"),
            wizardChoiceDescription : this.get("wizardChoiceDescription"),
            wizardChoiceLabel       : this.get("wizardChoiceLabel")
          });

          if (this.get("secondaryProducts").length>0)
          {
            objectToPush = this.get("secondaryProducts")[j];
            apartmentInterfaceItems.push({
              packageClassDescription : objectToPush.packageClassDescription,
              packageClassId          : objectToPush.packageClassId,
              packageClassLabel       : objectToPush.packageClassLabel,
              price                   : objectToPush.price,
              productCode             : objectToPush.productCode,
              productDescription      : objectToPush.productDescription,
              productInDepth          : objectToPush.productInDepth,
              productLabel            : objectToPush.productLabel,
              wizardChoiceDescription : objectToPush.wizardChoiceDescription,
              wizardChoiceLabel       : objectToPush.wizardChoiceLabel
            });
          }
        }
          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.apartmentInterfaceItems = apartmentInterfaceItems;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.apartmentInterfaceItems = apartmentInterfaceItems;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.apartmentInterfaceItems = apartmentInterfaceItems;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.apartmentInterfaceItems = apartmentInterfaceItems;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.apartmentInterfaceItems = apartmentInterfaceItems;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.apartmentInterfaceItems = apartmentInterfaceItems;
              break;
          }
        
        BticinoS4B.Instances.Models.ApplicationModel.set("apartmentInterfaceItems", apartmentInterfaceItems);
      },

      systemFilterUpdatedEventHandler : function() {
        var newFilterId     = BticinoS4B.Instances.Models.ApplicationModel.get("filterId");

        if ((newFilterId===1) || (newFilterId===2) || (newFilterId===4) || (newFilterId===5)) //If there's vde system
        {
          if (!this.get("enabled"))
            this.set("enabled", true);
        }
        else
        {
          if (this.get("enabled"))
            this.set("enabled", false);
        }

        this.trigger("render:requested");
        this.trigger("updateViews");
      }

    })
  });

  // Required, return the module for AMD compliance
  return apartmentInterface;

});